module.exports = __webpack_public_path__ + "static/media/menu_icon_homevisit_normal.63144b3f.png";